import React from 'react'

const Header = () => {
    return (
        <header>
            <h1>Sombrero Magico de la Fortuna</h1>
        </header>
    );
}

export default Header;